import { useAppSelector } from './useAppSelector';

export const useIsLawyerArea = () => {
  return useAppSelector(({ imposter }) => imposter.isLawyerArea);
};
